import axios from 'axios';

export async function updatePictogramEntities(pictogramId, payload) {
  const url = `/api/v2/pictogram/${pictogramId}/update-entities`
  return axios.post(url, payload);
}


export async function reversePictogramEntities(pictogramId, payload) {
  const url = `/api/v2/pictogram/${pictogramId}/components/bulk-actions`
  return axios.post(url, payload);
}
